module.exports = __webpack_public_path__ + "img/unesco.935b751e.png";